import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { Children } from 'neon-design-system';

const useStyles = makeStyles(theme => createStyles({
	wrapper: {
		marginBottom: theme.spacing(2)
	}
}));

interface ManageTemplateFormItemProps {
	children: Children;
	className?: string;
}

const ManageTemplateFormItem = (props: ManageTemplateFormItemProps): JSX.Element => {
	const classes = useStyles();
	const { children, className } = props;

	return (
		<div className={[classes.wrapper, className].filter(cn => !!cn).join(' ')}>
			{children}
		</div>
	);
};

export default ManageTemplateFormItem;
